import { InsurerView, Modal, PDFRenderer } from "components";
import { useMatch, useNavigate, useSearch } from "react-location";

import { Action } from "components/buttons/action-button";
import { LocationGenerics } from "router/location";
import config from "config";
import { useInsurer } from "hooks/data/use-insurers";
import { wrapClick } from "utils";

export default function ViewInsurerPaymentReceiptContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { params } = useMatch<LocationGenerics>();
  const navigate = useNavigate<LocationGenerics>();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="Payment Receipt"
      description="Details of payment receipt are shown below"
    >
      <PDFRenderer
        url={`${config.asset.uri}payment_receipt/${btoa(
          JSON.stringify({
            offer_id: params?.offer,
            payment_id: searchParams?.id,
          })
        )}`}
      />
    </Modal>
  );
}
